import Select from "react-select";
const MediaFileField = ({ name, value, media, param, onChange = () => {} }) => {
  const options = media.map((m) => {
    return { value: m.public_id, label: m.name };
  });
  return (
    <>
      <Select
        name={name}
        options={options}
        value={options.find((o) => o.value === value)}
        isMulti={param.multi ?? false}
        onChange={onChange}
      />
    </>
  );
};

export default MediaFileField;
